import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-9_caigou_no",
  "use": "icon-9_caigou_no-usage",
  "viewBox": "0 0 40 40",
  "content": "<symbol viewBox=\"0 0 40 40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-9_caigou_no\">\n<rect x=\"18.5\" y=\"8.19141\" width=\"13.0155\" height=\"8.82449\" rx=\"2\" transform=\"rotate(45 18.5 8.19141)\" fill=\"#D3E3F7\" />\n<path d=\"M9.28101 18.2481C9.1318 17.0544 10.0626 16 11.2656 16H28.7344C29.9374 16 30.8682 17.0544 30.719 18.2481L29.3285 29.3721C29.1408 30.8734 27.8646 32 26.3517 32H13.6483C12.1354 32 10.8592 30.8734 10.6715 29.3721L9.28101 18.2481Z\" fill=\"#BBD0EA\" />\n<path d=\"M20 22L20 26\" stroke=\"white\" stroke-opacity=\"0.9\" stroke-width=\"1.5\" stroke-linecap=\"round\" />\n<path d=\"M14.7388 22.0074L15.2617 25.9922\" stroke=\"white\" stroke-opacity=\"0.9\" stroke-width=\"1.5\" stroke-linecap=\"round\" />\n<path d=\"M25.2612 22.0074L24.7383 25.9922\" stroke=\"white\" stroke-opacity=\"0.9\" stroke-width=\"1.5\" stroke-linecap=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/9_caigou_no.svg
// module id = s94E
// module chunks = 45